import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboTopQueryRecommendationsResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.listTopQueryRecommendations;

const DBO_TOP_QUERY_RECOMMENDATIONS_QUERY_KEY = 'dbo-top-query-recommendations';

const getTopQueryRecommendationsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_TOP_QUERY_RECOMMENDATIONS_QUERY_KEY, params] as const;
};

export const useTopQueryRecommendationsQuery = <
  TSelected = DboTopQueryRecommendationsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboTopQueryRecommendationsResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getTopQueryRecommendationsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      placeholderData: keepPreviousData,
      ...options,
    })
  );
